module.exports = __webpack_public_path__ + "img/questions-bg.6e002f81.svg";